import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  viewChild,
} from '@angular/core';
import { Chip } from 'primeng/chip';
import { Popover } from 'primeng/popover';
import type { ChatSuggestionItem } from '../../services/chat-suggestions.service';

@Component({
  selector: 'lib-chat-suggestions-bar',
  standalone: true,
  imports: [Chip, Popover],
  templateUrl: './chat-suggestions-bar.component.html',
  styleUrls: ['./chat-suggestions-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatSuggestionsBarComponent {
  readonly suggestions = input.required<ChatSuggestionItem[]>();
  readonly chipsDisabled = input(false);

  readonly macroSelect = output<string>();

  private static readonly INITIAL_INLINE = 3;

  readonly suggestionsPopover = viewChild<Popover>('suggestionsPopover');

  readonly displayedChips = computed(() =>
    this.suggestions().slice(0, ChatSuggestionsBarComponent.INITIAL_INLINE)
  );

  readonly popoverChips = computed(() =>
    this.suggestions().slice(ChatSuggestionsBarComponent.INITIAL_INLINE)
  );

  readonly showViewAll = computed(
    () => this.suggestions().length > ChatSuggestionsBarComponent.INITIAL_INLINE
  );

  togglePopover(event: Event, anchor: HTMLElement): void {
    if (this.chipsDisabled()) {
      return;
    }
    this.suggestionsPopover()?.toggle(event, anchor);
  }

  onChipClick(macro: string): void {
    if (this.chipsDisabled()) {
      return;
    }
    this.macroSelect.emit(macro);
    this.suggestionsPopover()?.hide();
  }
}
